import AxiosIndicatorRunTimeLoader from "../../../component/AxiosIndicatorRunTimeLoader";
import React from "react";

class Product {
    static register = {
        PD_ADD_TO_CART: {slug: 'PD_ADD_TO_CART', render: <AxiosIndicatorRunTimeLoader/>},
        PD_ADD_TO_BOM: {slug: 'PD_ADD_TO_BOM'},
        PD_CLICK_TO_QUOTE: {slug: 'PD_CLICK_TO_QUOTE'},
        PD_CONTACT_US: {slug: 'PD_CONTACT_US'},
        PD_VIEW_CART: {slug: 'PD_VIEW_CART'},
        PD_SIGN_IN_ABACUS_PRICE: {slug: 'PD_SIGN_IN_ABACUS_PRICE'},
        PDG_ADD_TO_CART:{slug:'PDG_ADD_TO_CART', render: <></>},
        PDG_ADD_TO_BOM: {slug:'PDG_ADD_TO_BOM', render: <></>},
        PDG_CLICK_TO_QUOTE:{slug:'PDG_CLICK_TO_QUOTE', render: <></>},
        PDG_VIEW_CART: {slug: 'PDG_VIEW_CART',render:<></>},
        
    };

    static register_external = {
        PD_ADD_TO_BOM: {slug: 'PD_ADD_TO_BOM',render:<></>}
    }

    static register_guest = {
        PDG_ADD_TO_CART:{slug:'PDG_ADD_TO_CART', render: <></>},
        PDG_ADD_TO_BOM: {slug:'PDG_ADD_TO_BOM', render: <></>},
        PDG_CLICK_TO_QUOTE:{slug:'PDG_CLICK_TO_QUOTE', render: <></>},
        PDG_VIEW_CART: {slug: 'PDG_VIEW_CART',render:<></>},
    }
}

export default Product;